export default {"src":"/_next/static/media/instagram.dfd0ee6a.svg","height":13,"width":12,"blurWidth":0,"blurHeight":0};